import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import { DatePicker } from '@mui/x-date-pickers'

import { SelectString } from '../../../../core/components/SelectString'
import { StyledError } from '../../../../theme/components/StyledError'
import { useUpdateSubprocesForEntity } from '../../hooks/useUpdateSubprocesForEntity'
import type { Subproces } from '../../types/Subproces'
import { SCHOUW_HERPLAN_REDENEN } from '../../types/SubprocesRedenen'

interface Props {
  subproces: Subproces
  onClose: () => void
}

export const HerplanSchouw = ({ subproces, onClose }: Props) => {
  const { mutate: updateSubprocesForEntity, error } =
    useUpdateSubprocesForEntity()

  const [dueDate, setDueDate] = useState<Date | null>(null)
  const [reden, setReden] = useState<string | null>(null)

  const onSubmitClick = () => {
    const proces: Partial<Subproces & { text: string }> = {
      _id: subproces._id,
      // @ts-expect-error - button is disabled when dueDate is null
      dueDate: dueDate.toISOString(),
      status: subproces.status,
      // @ts-expect-error - button is disabled when reden is null
      text: reden,
    }

    const body = {
      entity: subproces.entity,
      subprocesInfo: proces,
    }

    updateSubprocesForEntity(body, { onSuccess: () => onClose() })
  }

  return (
    <>
      <DialogContent>
        <StyledError error={error} />
        <Grid container sx={{ width: '100%' }} spacing={1}>
          <Grid size={{ xs: 6 }}>
            <DatePicker
              label="Nieuwe geplande uitvoerdatum"
              value={dueDate}
              onChange={setDueDate}
              displayWeekNumber
              disablePast
              slotProps={{
                field: { clearable: true },
                textField: {
                  variant: 'standard',
                  sx: { pr: 1 },
                  fullWidth: true,
                },
              }}
            />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <SelectString
              value={reden}
              onChange={setReden}
              fullWidth
              options={SCHOUW_HERPLAN_REDENEN}
              label="Reden van herplanning"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose} autoFocus>
          Annuleren
        </Button>
        <Button
          onClick={onSubmitClick}
          variant={'contained'}
          disabled={!dueDate || !reden}
          color="primary"
        >
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
